__turbopack_context__.v({
  "cta": "ProductFilm-module__TKMghq__cta",
  "duration": "ProductFilm-module__TKMghq__duration",
  "frame": "ProductFilm-module__TKMghq__frame",
  "icon": "ProductFilm-module__TKMghq__icon",
  "overlay": "ProductFilm-module__TKMghq__overlay",
  "poster": "ProductFilm-module__TKMghq__poster",
  "scrim": "ProductFilm-module__TKMghq__scrim",
  "video": "ProductFilm-module__TKMghq__video",
});
